import React from "react";

const IotConnectionIcon = ({
    width = 23,
    height = 23,
    viewBox = "0 0 23 23",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.30245 4.28256C3.9282 4.65682 3.9282 5.26359 4.30245 5.63785C4.6767 6.0121 5.28348 6.0121 5.65774 5.63785C6.42494 4.87064 7.33575 4.26206 8.33815 3.84685C9.34056 3.43164 10.4149 3.21794 11.4999 3.21794C12.5849 3.21794 13.6592 3.43164 14.6617 3.84685C15.6641 4.26206 16.5749 4.87064 17.3421 5.63784C17.7163 6.0121 18.3232 6.0121 18.6974 5.63784C19.0716 5.26359 19.0716 4.65682 18.6974 4.28256C17.7522 3.33737 16.6301 2.58761 15.3952 2.07608C14.1603 1.56455 12.8366 1.30127 11.4999 1.30127C10.1632 1.30127 8.83963 1.56455 7.60468 2.07608C6.36973 2.58761 5.24763 3.33737 4.30245 4.28256Z"
            fill="url(#paint0_linear_6180_98354)"
        />
        <path
            d="M7.30889 8.66899C6.93463 8.29474 6.93463 7.68795 7.30889 7.31371C7.85929 6.76331 8.51271 6.3267 9.23184 6.02883C9.95098 5.73095 10.7218 5.57764 11.5001 5.57764C12.2785 5.57764 13.0493 5.73095 13.7684 6.02883C14.4875 6.3267 15.1409 6.76331 15.6914 7.31371C16.0656 7.68795 16.0656 8.29474 15.6914 8.66899C15.3171 9.04325 14.7103 9.04325 14.336 8.66899C13.9636 8.29657 13.5215 8.00115 13.0349 7.7996C12.5483 7.59804 12.0268 7.4943 11.5001 7.4943C10.9734 7.4943 10.4519 7.59804 9.96535 7.7996C9.47873 8.00115 9.0366 8.29657 8.66418 8.66899C8.28993 9.04325 7.68314 9.04325 7.30889 8.66899Z"
            fill="url(#paint1_linear_6180_98354)"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.5 9.5835C9.91214 9.5835 8.625 10.8707 8.625 12.4585C8.625 13.7153 9.4313 14.7836 10.5548 15.1745C10.5462 15.2263 10.5417 15.2793 10.5417 15.3335V16.2918C10.5417 17.3504 9.68357 18.2085 8.625 18.2085H5.75C5.75 17.15 4.89188 16.2918 3.83333 16.2918H1.91667C0.85812 16.2918 0 17.15 0 18.2085V20.1252C0 21.1837 0.85812 22.0418 1.91667 22.0418H3.83333C4.89188 22.0418 5.75 21.1837 5.75 20.1252H8.625C9.76992 20.1252 10.7976 19.6233 11.5 18.8275C12.2024 19.6233 13.2301 20.1252 14.375 20.1252H17.25C17.25 21.1837 18.1081 22.0418 19.1667 22.0418H21.0833C22.1419 22.0418 23 21.1837 23 20.1252V18.2085C23 17.15 22.1419 16.2918 21.0833 16.2918H19.1667C18.1081 16.2918 17.25 17.15 17.25 18.2085H14.375C13.3164 18.2085 12.4583 17.3504 12.4583 16.2918V15.3335C12.4583 15.2793 12.4538 15.2263 12.4452 15.1745C13.5687 14.7836 14.375 13.7153 14.375 12.4585C14.375 10.8707 13.0879 9.5835 11.5 9.5835ZM12.4583 12.4585C12.4583 12.9878 12.0293 13.4168 11.5 13.4168C10.9707 13.4168 10.5417 12.9878 10.5417 12.4585C10.5417 12.4254 10.5433 12.3928 10.5466 12.3606C10.5957 11.8773 11.0038 11.5002 11.5 11.5002C12.0293 11.5002 12.4583 11.9293 12.4583 12.4585ZM19.1667 20.1252H21.0833V18.2085H19.1667V20.1252ZM1.91667 20.1252H3.83333V18.2085H1.91667V20.1252Z"
            fill="url(#paint2_linear_6180_98354)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_6180_98354"
                x1="11.4999"
                y1="1.30127"
                x2="11.3283"
                y2="12.8731"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8E92FF" />
                <stop offset="1" stopColor="#0007B7" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_6180_98354"
                x1="11.5001"
                y1="5.57764"
                x2="11.6717"
                y2="9.44025"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8E92FF" />
                <stop offset="1" stopColor="#0007B7" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_6180_98354"
                x1="11.6716"
                y1="-0.85799"
                x2="11.5"
                y2="22.0418"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8E92FF" />
                <stop offset="1" stopColor="#0007B7" />
            </linearGradient>
        </defs>
    </svg>
);

export default IotConnectionIcon;
